export default "__VITE_ASSET__783ed314__"